import {Theme} from "@mui/material/styles";
import {SectionStatus} from "../../utils/contaminationDeclaration/gating";

/**
 * Base color per section status — the single source for the progress panel's
 * dots and the section chips, so both always read the same.
 */
export const sectionStatusColor = (theme: Theme, status: SectionStatus): string => {
    if (status === 'complete') return theme.palette.success.main;
    if (status === 'missing') return theme.palette.warning.main;
    return theme.palette.grey[400];
};
